import Phaser from 'phaser';
import { Depth, GAME_H, GAME_W } from '../config';
import { SceneKeys } from './keys';
import { attachUiIfAvailable } from '../wiring';

/**
 * Persistent overlay scene. The save/UI builder extends this with dialogue box, prompts, pause and
 * settings; the integrator keeps the fade contract used by Router.
 */
export class UIScene extends Phaser.Scene {
  private curtain!: Phaser.GameObjects.Rectangle;
  constructor() { super(SceneKeys.UI); }

  create(): void {
    this.curtain = this.add.rectangle(0, 0, GAME_W, GAME_H, 0x000000).setOrigin(0).setDepth(Depth.UI + 900).setAlpha(0);
    this.scene.bringToTop();
    attachUiIfAvailable(this);
  }

  fade(out: boolean, ms: number): Promise<void> {
    return new Promise((resolve) => {
      this.tweens.killTweensOf(this.curtain);
      this.tweens.add({ targets: this.curtain, alpha: out ? 1 : 0, duration: ms, ease: 'Linear', onComplete: () => resolve() });
    });
  }
}
